import * as Yup from 'yup';

export const expirationCardDateValidator = (
  fieldInput = '',
  startYear = '20',
) => {
  const getMonth = fieldInput.split('/')[0];
  const getYear = `${startYear}${fieldInput.split('/')[1]}`;
  const currentDate = new Date();
  return (
    (parseInt(getYear) === currentDate.getFullYear() &&
      parseInt(getMonth) < currentDate.getMonth() + 1) ||
    parseInt(getYear) < currentDate.getFullYear()
  );
};

export const creditCardValidationRegex = {
  Visa: {
    numberRegex: /^4[0-9]{15}$/,
    cvvRegex: /^[0-9]{3}$/,
  },
  MasterCard: {
    numberRegex:
      /(^5[1-5][0-9]{14}$)|((^222[1-9]|^22[3-9][0-9]|^2[3-6][0-9][0-9]|^27[0-1][0-9]|^2720)[0-9]{12}$)/,
    cvvRegex: /^[0-9]{3}$/,
  },
};

export const getMatchedPattern = (
  creditCardValidationNode,
  regexNode,
  fieldValueNode,
  creditCardTypeNode,
) => {
  const getNames = Object.entries(creditCardValidationNode).reduce(
    (all, item) => {
      if (fieldValueNode) {
        const [cardName, cardRegExp] = item;
        const getNumberRegExp = cardRegExp[regexNode];
        const matchedPattern = Yup.object().shape({
          test: Yup.string().matches(getNumberRegExp),
        });
        const validatePattern = matchedPattern.isValidSync({
          test: fieldValueNode,
        });
        all.push({
          name: cardName,
          isValid: validatePattern,
          type: creditCardTypeNode[cardName],
        });
      }

      return all;
    },
    [],
  );
  return getNames;
};

export const getEmailRegExRules = (
  regExRulesDataCodes,
  defaultPattern,
  codeName,
  additionalPropertiesKey,
) => {
  if (!regExRulesDataCodes?.length) {
    return defaultPattern;
  }

  const itemFromCodeTable = regExRulesDataCodes.find(
    (dataCode) => dataCode?.Name === codeName,
  );
  const getAdditionalProps = (additionalProperties) => {
    if (!additionalProperties?.length) {
      return defaultPattern;
    }
    const regExpAsString = additionalProperties.find(
      (additionalProperty) =>
        additionalProperty?.Key === additionalPropertiesKey,
    );
    if (!regExpAsString?.Value) {
      return defaultPattern;
    }
    return new RegExp(regExpAsString.Value);
  };
  const getItemFromCodeTable = (itemFromCodeTable) => {
    if (!itemFromCodeTable) {
      return defaultPattern;
    }
    const { AdditionalProperties } = itemFromCodeTable;
    return getAdditionalProps(AdditionalProperties);
  };
  return getItemFromCodeTable(itemFromCodeTable);
};
